import React from 'react';
import {
    dagaAsh01,
    dagaAsh02,
    dagaAsh03,
    dagaAsh04,
    dagaAsh05,
    dagaAsh06,
    dagaAsh07,
    dagaAsh08,
    dagaAsh09,
    dagaAsh10,
    dagaAsh11,
    dagaAsh12,
    dagaAsh13,
    dagaAsh14,
    dagaAsh15,
    dagaAsh16,
    dagaAsh17,
    dagaAsh18,
    dagaAsh19,
    dagaAsh20,
    dagaAsh21,
    dagaAsh22,
    dagaAsh23,
    dagaAsh24,
    dagaAsh25,
    dagaAsh26,
    dagaAsh27,
    dagaAsh28,
    dagaAsh29,
    dagaAsh30,
    dagaAsh31,
    dagaAsh32,
    dagaAsh33,
    dagaAsh34,
    dagaAsh35,
    dagaAsh36,
    dagaAsh37,
    dagaAsh38,
    dagaAsh39,
    dagaAsh40,
    dagaAsh41,
    dagaAsh42,
    dagaAsh43,
    dagaAsh44,
    dagaAsh45,
    dagaAsh46,
    dagaAsh47,
    dagaAsh48,
} from '../OurCouplesPics/DagaAsh';

export const DagaAndAsh = {
    bgColor: "bgGrey",
    title: "Daga i Ash - zimowe wesele z widokiem na Tatry",
    path: "zimowe-wesele-w-tatrach",
    minHeight: true,
    seoTitle: "Zimowe wesele z widokiem na Tatry | Czarny Marry agencja ślubna",
    seoText: "Zimowe wesele w Tatrach pełne ciepła, światła i emocji – elegancka uroczystość Dagi i Asha w drewnianych wnętrzach Ziębówki, gdzie góry spotkały się z miłością.",
    mainPic: {
        src: dagaAsh01
    },
    details: "Zimowe wesele w Tatrach pełne ciepła, światła i emocji – elegancka uroczystość Dagi i Asha w drewnianych wnętrzach Ziębówki, gdzie góry spotkały się z miłością.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Ziębówka",
    placeLink: "",
    photo: "Nikola Baron",
    photoLink: "",
    decor: "Anello Decor",
    decorLink: "https://www.facebook.com/anellodecor",
    movie: "Black Heart Studio",
    movieLink: "",
    makeup: "Maria Florczyk",
    makeupLink: "",
    hair: "Basia Luberda",
    hairLink: "",
    date: "23 lis 2025",
    textMain:
        <>
            Czasem miejsce samo podpowiada, jak ma wyglądać ten dzień. Drewniana Ziębówka w Witowie, otulona zimowym krajobrazem Tatr, stała się dla Dagi i Asha idealnym tłem do powiedzenia sobie „tak”. Choć na co dzień mieszkają w Australii, marzyli o kameralnym, ciepłym weselu w Polsce – wśród natury, przy blasku świec i w gronie najbliższych. Ich dzień był pełen emocji, światła i prawdziwej radości.
        </>,
    topPic: { src: dagaAsh02 },
    content: [
        {
            headerSmall: 'Przygotowania pełne radości',
            headerClassName: "grey",
            text: <><p>Dzień rozpoczął się spokojnie, w atmosferze ekscytacji i dobrego humoru. Daga i Ash przygotowywali się osobno, w apartamentach niedaleko sali.
                Daga, w otoczeniu druhen i siostry, od początku promieniała uśmiechem. Jej stylizacja była wyjątkowa – dopasowana suknia z koronkowymi detalami i subtelnym połyskiem idealnie podkreślała sylwetkę. Futrzane bolerko i masywne białe buty dodawały całości charakteru, a lekko niedbały warkocz sprawiał, że wyglądała jak uosobienie zimowej elegancji.</p>
                <p>Ash przygotowywał się z grupą przyjaciół – w granatowym garniturze z kamizelką i czarnym krawatem prezentował się klasycznie, ale z lekkością. Swobodny styl i naturalny luz świetnie wpisywały się w atmosferę dnia. Razem z drużbami w szarościach tworzył elegancką, spójną ekipę.</p></>,
            pics: [
                { src: dagaAsh03 },
                { src: dagaAsh04 },
                { src: dagaAsh05 },
                { src: dagaAsh06 },
                { src: dagaAsh07 },
                { src: dagaAsh08 },
                { src: dagaAsh09 },
                { src: dagaAsh10 },
                { src: dagaAsh11 },
            ]
        },
        {
            headerSmall: "Ślub z widokiem na góry",
            headerClassName: "grey",
            text: <><p>Ceremonia odbyła się na drewnianym tarasie Ziębówki z zapierającą dech panoramą Tatr. W promieniach zimowego słońca, przy dźwiękach cichych rozmów i śmiechu, Daga i Ash złożyli sobie własne przysięgi. Uroczystość prowadziła urzędniczka, która przygotowała dla nich osobistą, ciepłą mowę o miłości – idealnie dopasowaną do ich historii.</p>
                <p>Druhny w głębokiej zieleni i drużbowie w eleganckich garniturach pięknie komponowali się z otaczającym krajobrazem. Złote promienie słońca i lekki chłód powietrza sprawiły, że ten moment był magiczny – pełen spokoju i emocji.</p></>,
            pics: [
                { src: dagaAsh12 },
                { src: dagaAsh13 },
                { src: dagaAsh14 },
                { src: dagaAsh15 },
                { src: dagaAsh16 },
                { src: dagaAsh17 },
                { src: dagaAsh18 },
                { src: dagaAsh19 },
                { src: dagaAsh20 },
                { src: dagaAsh21 },
            ]
        },
        {
            headerSmall: "Druhny i drużbowie -  ekipa, która niosła energię",
            headerClassName: "grey",
            text: "Daga i Ash mieli przy sobie wyjątkową ekipę — drużyny pełne energii, wsparcia i niewymuszonej radości. Zielone suknie druhen pięknie korespondowały z zimową paletą wesela, a drużbowie w eleganckich zestawach dodawali całości charakteru. Razem tworzyli grupę, która nie tylko towarzyszyła Parze podczas przygotowań, ale też niosła dobrą energię przez cały dzień. Były żarty, śmiech, spontaniczne reakcje i ta fajna, lekka atmosfera, która sprawia, że dzień staje się jeszcze piękniejszy. Ich obecność była jednym z najmocniejszych elementów tego wesela - dodali mu koloru, luzu i szczerego ciepła.",
            pics: [
                { src: dagaAsh22 },
                { src: dagaAsh23 },
                { src: dagaAsh24 },
                { src: dagaAsh25 },
                { src: dagaAsh26 },
            ]
        },
        {
            headerSmall: "Ziębówka – drewniany dom pełen ciepła",
            headerClassName: "grey",
            text: <><p>Ziębówka to miejsce, które samo w sobie ma klimat – naturalne drewno, przytulne wnętrza i miękkie światło tworzą przestrzeń, w której od razu można poczuć się dobrze. Dekoracje Dagi i Asha pięknie dopełniły charakter tego miejsca.</p><p>Na stołach pojawiły się kompozycje z iglaków, eukaliptusa, anemonów i róż w odcieniach bieli i zieleni, uzupełnione drobnymi szyszkami i złotymi akcentami. Obrusy w odcieniu gołębiej szarości idealnie podbiły delikatność kwiatów i świeżej zieleni. Blask świec ocieplił drewniane wnętrze, tworząc romantyczny, przytulny nastrój. Papeteria – menu i winietki na czerpanym papierze – dopełniły całości, wprowadzając subtelny, elegancki detal.</p></>,
            pics: [
                { src: dagaAsh27 },
                { src: dagaAsh28 },
                { src: dagaAsh29 },
                { src: dagaAsh30 },
                { src: dagaAsh31 },
                { src: dagaAsh32 },
                { src: dagaAsh33 },
                { src: dagaAsh34 },
                { src: dagaAsh35 },
            ]
        },
        {
            headerSmall: "Zimowa uczta i folkowe dźwięki",
            headerClassName: "grey",
            text: <><p>Wesele Dagi i Asha było kameralne – około 60 najbliższych osób, wśród których wielu przyleciało z Australii. W menu znalazły się lokalne smaki, a w trakcie obiadu zagrała góralska kapela – prezent od rodziców Panny Młodej. Ich muzyka porwała wszystkich i dodała wydarzeniu autentycznego, folkowego klimatu.</p><p>Wieczorem przy Ziębówce zapłonęło ognisko, wokół którego toczyły się rozmowy i powstawały kadry pełne uśmiechów. Wewnątrz na gości czekał barman z autorskimi drinkami, a później – parkiet i taniec do białego rana.</p></>,
            pics: [
                { src: dagaAsh36 },
                { src: dagaAsh37 },
                { src: dagaAsh38 },
                { src: dagaAsh39 },
                { src: dagaAsh40 },
                { src: dagaAsh41 },
                { src: dagaAsh42 },
                { src: dagaAsh43 },
                { src: dagaAsh44 },
                { src: dagaAsh45 },
                { src: dagaAsh46 },
                { src: dagaAsh47 },
            ]
        },
        {
            headerSmall: "Miłość, ciepło i góry",
            headerClassName: "grey",
            text: <><p>To był dzień, w którym zimowy krajobraz spotkał się z ciepłem emocji. Subtelny blask świec, naturalne dekoracje i energia Pary sprawiły, że to wesele miało w sobie wszystko – elegancję, radość i szczerość.</p><p>Daga i Ash stworzyli dzień pełen miłości, światła i wdzięczności – taki, który zostaje w sercu na długo.</p></>,
            pics: [
                { src: dagaAsh48 },
            ]
        },
    ],
}